import { addDataLayerEntry } from '@printdeal/data-layer-manager';
import { Product } from '../../types/product/productDetailPage';

interface EventProps {
  eventCategory: string;
  eventAction: string
  eventLabel?: string;
}

interface ProductImpressionProps {
  id?: string;
  productName?: string;
  /**
   * @deprecated use the product from the selector instead
   * @example `selector.product.name`
   */
  parentProduct?: Partial<Product>;
  productCategory?: {
    categoryName?: string;
  };
}

export const dispatchDataLayerEventOnClick = (event: EventProps) => {
  const { eventCategory, eventAction, eventLabel } = event;
  addDataLayerEntry('gaEvent', {
    gaEvent: {
      eventCategory,
      eventLabel,
      eventAction,
      eventNonInteraction: false,
    },
  });
};

export const dispatchDataLayerProductClick = (
  categoryPage: string,
  product: ProductImpressionProps,
  productIndex: number,
  placementId?: string, // In case if recommendations are shown
  placementName?: string, // In case if recommendations are shown
) => {
  // GA3
  addDataLayerEntry('gaEventEec', {
    gaEvent: {
      eventCategory: 'ecommerce',
      eventAction: 'click',
      eventLabel: product.productName || undefined,
      eventNonInteraction: false,
    },
    ecommerce: {
      click: {
        actionField: {
          list: `Product Listing Page - ${categoryPage}`,
        },
        products: [{
          name: product?.productName || undefined,
          id: product.id || '',
          dimension39: product?.productName || undefined,
          category: product?.productCategory?.categoryName || undefined,
          position: `${productIndex + 1}`,
          contentful_id: product.id,
        }],
      },
    },
  });

  // GA4
  addDataLayerEntry('select_item', {
    item_list_id: `product_listing_page_${categoryPage.replace(/ /g, '_')}`,
    item_list_name: `Product Listing Page - ${categoryPage}`,
    recommendation_id: placementId,
    recommendation_name: placementName,
    items: [{
      item_id: product.id || '',
      item_name: product?.productName || undefined,
      item_category: product?.productCategory?.categoryName || undefined,
      index: `${productIndex + 1}`,
      contentful_id: product.id,
      item_list_id: `product_listing_page_${categoryPage.replace(/ /g, '_')}`,
      item_list_name: `Product Listing Page - ${categoryPage}`,
    }],
  });
};

export const dispatchDataLayerProductImpressions = (
  category: string,
  impressions: ProductImpressionProps[],
  placementId?: string, // In case if recommendations are shown
  placementName?: string, // In case if recommendations are shown
) => {
  // GA3
  addDataLayerEntry('gaEventEec', {
    gaEvent: {
      eventCategory: 'ecommerce',
      eventAction: 'impressions',
      eventNonInteraction: true,
    },
    ecommerce: {
      impressions: impressions.map((product, index) => ({
        name: product?.productName || undefined,
        id: product?.id || '',
        dimension39: product?.productName || undefined,
        category,
        list: `Product Listing Page - ${category}`,
        position: index + 1,
      })),
    },
  });

  // GA4
  addDataLayerEntry('view_item_list', {
    item_list_id: `product_listing_page_${category.replace(/ /g, '_')}`,
    item_list_name: `Product Listing Page - ${category}`,
    recommendation_id: placementId,
    recommendation_name: placementName,
    items: impressions.map((product, index) => ({
      item_id: product?.id || '',
      item_name: product?.productName || undefined,
      item_category: product.productCategory?.categoryName || undefined,
      index: index + 1,
      contentful_id: product.id,
      item_list_id: `product_listing_page_${category.replace(/ /g, '_')}`,
      item_list_name: `Product Listing Page - ${category}`,
    })),
  });
};
